module.exports = __webpack_public_path__ + "img/vote_qrcode.930ff514.jpg";